import React, { useEffect, useState } from "react";
import { Cnt } from "../../Cnt.ThreeDeeCrate.Public.SDK/Cnt.ThreeDeeCrate.Public.SDK";
import { AppSettings } from "../../AppSettings";
import { Button, Spinner } from "react-bootstrap";
import './SubscribeButton.scss';

interface SubscribeButtonProps {
  user: Cnt.ThreeDeeCrate.SDK.UserDTO | null;
}

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState<boolean | null>(null);
  const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.PublicAPIUrl);

  const fetchSubscriptionStatus = async () => {
    try {
    setLoading(true);
      const subscription = await api.subscription.CheckIsSubscribed();
      setIsSubscribed(subscription?.IsSubscribed ?? false);
      setLoading(false); // Just in case redirect doesn't happen
    } catch (error) {
      console.error("🔴 Failed to fetch subscription status", error);
      setLoading(false); // Just in case redirect doesn't happen
    }
  };

  useEffect(() => {
    if (user?.Id) {
      fetchSubscriptionStatus();
    }
  }, [user?.Id]);

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const subscriptionUrl = await api.subscription.GetSubscribeUrl({
        Url: window.location.href,
      });
      window.location.href = subscriptionUrl.Url ?? window.location.href;
    } catch (error) {
      console.error("❌ Failed to start subscription", error);
      setLoading(false); // Just in case redirect doesn't happen
    }
  };

  const handleUnsubscribe = async () => {
    setLoading(true);
    try {
      const result = await api.subscription.CancelSubscription();
      setIsSubscribed(result?.IsSubscribed ?? false);
    } catch (error) {
      console.error("❌ Failed to cancel subscription", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={isSubscribed ? handleUnsubscribe : handleSubscribe}
      variant={isSubscribed ? "secondary" : "warning"}
      disabled={loading}
      className="d-inline-flex align-items-center rounded-pill"
    >
      {loading && <Spinner animation="border" size="sm" className="me-2" />}
      {isSubscribed ? "Unsubscribe" : "Subscribe"}
    </Button>
  );
};
